import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=5217dbae&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=5217dbae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5217dbae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5217dbae')) {
      api.createRecord('5217dbae', component.options)
    } else {
      api.reload('5217dbae', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=5217dbae&scoped=true&", function () {
      api.rerender('5217dbae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4KSx5UDvVm1hX/JS/comp/CookieBox.vue"
export default component.exports